/**
 * Config lengths: `tradeInConfig` takes sizes as a bare number of px or any CSS length string.
 */

/** Normalise a config length for an inline style (number → px, string → as-is, unset → undefined). */
export function cssLength(v?: number | string): string | undefined {
  if (v == null) return undefined
  return typeof v === 'number' ? `${v}px` : v
}
